import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApiSpecificationsDataDownloadService } from 'src/app/services/api-specifications-data-download.service';

@Component({
  selector: 'app-specifications-data-download',
  templateUrl: './specifications-data-download.component.html',
  styleUrls: ['./specifications-data-download.component.css']
})
export class SpecificationsDataDownloadComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  orgAndProductIds: Object;
  switchTab: string = 'settings';

  @Input() set data(value) {

    if (value != null) {

      this.orgAndProductIds = {
        org_id: value.org_id,
        product_ids: value.product_ids
      }

    }
  }

  constructor(
    public activeModal: NgbActiveModal,
    private downloadSpecificationsService: ApiSpecificationsDataDownloadService
  ) { }

  ngOnInit(): void {

    this.subscriptions.add(

      this.downloadSpecificationsService.listenerSwitchTab().subscribe(val => {

        if (val) {

          this.switchTab = 'settings';
        }

      })
    );
  }

  /**
   * 
   * @param tab 
   */
  switchTabs(tab: string) {

    this.switchTab = tab;

  }

}
